import React from 'react';

const ParentComponent = () => {
    return (
        <div>
        </div>
    );
};

export default ParentComponent;
